import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base.component';
@Component({
  selector: 'app-marketing-tool',
  templateUrl: './marketing-tool.component.html',
  styleUrls: ['./marketing-tool.component.css']
})
export class MarketingToolComponent  extends BaseComponent implements OnInit {
 constructor() { super(); }

  customerID=0;
  roleID;

  ngOnInit() {

    var customerInfo =  JSON.parse(sessionStorage.getItem("userData"));
    this.customerID= customerInfo.admin_customer_id; 
    this.roleID=customerInfo.role_id;
  

  }


}
